// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'people-group-stakeholders';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='1.5'
    d='M8.5 4.3c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5S13.9.8 12 .8 8.5 2.4 8.5 4.3zm7.7 6.6c-2.4-2.2-6-2.2-8.4 0m8 5.9c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5zm8.4 7.4c-2.1-2.7-6.1-3.2-8.8-1.1-.4.3-.8.7-1.1 1.1M2.2 16.8c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5zm8.5 7.4c-2.1-2.7-6.1-3.2-8.8-1.1-.4.3-.8.7-1.1 1.1'
  />
);

export const viewBox = '0 0 25 25';
